export enum ReviewSource {
    TrustYou = "trustyou",
    TripAdvisor = "tripadvisor",
}
